import { usePreventScroll } from '@/hooks/usePreventScroll';
import { useCallback, useState } from 'react';

type ModalType = 'enable' | 'disable' | null;

export const useOfficeSettingModalControl = () => {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  usePreventScroll(openModal !== null);
  const handleOpenEnableModal = useCallback(() => {
    setOpenModal('enable');
  }, []);

  const handleOpenDisableModal = useCallback(() => {
    setOpenModal('disable');
  }, []);

  const handleCloseModal = useCallback(() => {
    setOpenModal(null);
  }, []);

  return {
    openModal,
    handleOpenEnableModal,
    handleOpenDisableModal,
    handleCloseModal,
  };
};
